import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function TabNavigation({
  tabs,
  activeTab,
  onChange
}) {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  // Check if scrolling is needed and update arrow visibility
  const checkForScrolling = () => {
    if (scrollContainerRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1); // -1 for rounding errors
    }
  };
  // Handle scrolling when arrows are clicked
  const handleScroll = direction => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  // Initial check and add listeners
  useEffect(() => {
    checkForScrolling();
    // Set up scroll event listener
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', checkForScrolling);
    }
    // Set up resize observer to recheck when window size changes
    const resizeObserver = new ResizeObserver(checkForScrolling);
    if (scrollContainer) {
      resizeObserver.observe(scrollContainer);
    }
    // Check again after a short delay to ensure accurate measurements
    setTimeout(checkForScrolling, 100);
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', checkForScrolling);
      }
      resizeObserver.disconnect();
    };
  }, [tabs]);
  return <div className="border-b border-gray-200 relative" data-id="element-482">
      {/* Left scroll indicator */}
      {showLeftArrow && <button onClick={() => handleScroll('left')} className="absolute left-0 top-0 bottom-0 bg-gradient-to-r from-blue-50 via-blue-50 to-transparent z-10 px-2 flex items-center justify-center" aria-label="Scroll tabs left" data-id="element-483">
          <div className="w-8 h-8 rounded-full bg-blue-100 border-2 border-blue-200 shadow-md flex items-center justify-center transition-all hover:bg-blue-200" data-id="element-484">
            <ChevronLeftIcon className="w-5 h-5 text-blue-700" data-id="element-485" />
          </div>
        </button>}
      {/* Tabs scrollable container */}
      <div ref={scrollContainerRef} className="flex overflow-x-auto hide-scrollbar relative scroll-smooth" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-486">
        {tabs.map(tab => <button key={tab.id} className={`px-4 py-3 font-medium text-sm whitespace-nowrap flex items-center gap-1.5 ${activeTab === tab.id ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => onChange(tab.id)} data-id="element-487">
            {tab.icon}
            {tab.label}
          </button>)}
      </div>
      {/* Right scroll indicator */}
      {showRightArrow && <button onClick={() => handleScroll('right')} className="absolute right-0 top-0 bottom-0 bg-gradient-to-l from-blue-50 via-blue-50 to-transparent z-10 px-2 flex items-center justify-center" aria-label="Scroll tabs right" data-id="element-488">
          <div className="w-8 h-8 rounded-full bg-blue-100 border-2 border-blue-200 shadow-md flex items-center justify-center transition-all hover:bg-blue-200" data-id="element-489">
            <ChevronRightIcon className="w-5 h-5 text-blue-700" data-id="element-490" />
          </div>
        </button>}
      {/* Add some CSS to hide scrollbar but allow scrolling */}
      <style jsx data-id="element-491">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>;
}